module.exports = __webpack_public_path__ + "h5/img/li.0beed831.jpg";